package services.auth.http

import it.neckar.lizergy.model.company.CompanyCode
import it.neckar.rest.RestResponse
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * Response for
 */
@Serializable
sealed interface ChangedCompanyInfoResponse : RestResponse<CompanyCode> {

  @Serializable
  @SerialName("good")
  data class Good internal constructor(override val data: CompanyCode) : ChangedCompanyInfoResponse, RestResponse.GoodResponse<CompanyCode>

  @Serializable
  @SerialName("bad/Failed")
  data class Failed(val errorType: ErrorType) : ChangedCompanyInfoResponse, RestResponse.BadResponse<CompanyCode> {

    enum class ErrorType {
      CompanyNotFound,
      FailToFetch,
    }
  }

  companion object {
    /**
     * Helper method to create a success object - with the correct type
     */
    fun good(data: CompanyCode): ChangedCompanyInfoResponse = Good(data)

    /**
     * Helper method to create a failure object - with the correct type
     */
    fun bad(errorType: Failed.ErrorType): ChangedCompanyInfoResponse = Failed(errorType)
  }
}
